(function () {
  "use strict";

  class RrpPricingComponent extends HTMLElement {
    constructor() {
      super();
      this.currentVariantId = null;
    }

    static get observedAttributes() {
      return ["product"];
    }

    get product() {
      return this._product;
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      if (this._product) {
        this.render();
      }
    }

    formatPrice(cents, format) {
      if (!cents) return "";

      const rccContainer = document.querySelector(".rcc-search") || document.querySelector(".rcc-reccomendations");
      const money = rccContainer?.dataset.moneyFormat;

      cents = +cents * 100;
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString =
        money.replace(/<[^>]*>/g, "") ||
        money ||
        format ||
        "amount_no_decimals";

      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ",",
        decimal = "."
      ) {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
          price = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          cents = parts[1] ? decimal + parts[1] : "";

        return price + cents;
      }

      var match = format ? [, format] : formatString.match(placeholderRegex);

      if (match) {
        switch (match[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ", " ");
            break;
          case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        }
      }

      return formatString.replace(placeholderRegex, value.toString());
    }

    async render() {
      let rrp = await this.getVariantRRP();
      if (!rrp) {
        rrp =
          this._product.metafields?.[0]?.value ||
          this._product.priceInfo?.originalPrice;
      }

      const rccContainer = document.querySelector(".rcc-search") || document.querySelector(".rcc-reccomendations");
      const isB2B = rccContainer?.dataset.customerB2b === "true";

      const price = this._product.priceInfo?.price;
      const originalPrice = isB2B
        ? rrp
        : this._product.priceInfo?.originalPrice;

      const isReduced = originalPrice && price && +originalPrice - +price > 0;

      const priceAnnouncement = isReduced
        ? `Sale price: ${this.formatPrice(price)}, was ${this.formatPrice(
            originalPrice
          )}`
        : `Price: ${this.formatPrice(price)}`;

      this.innerHTML = `
      <p class="rcc-search__product__price" aria-label="${priceAnnouncement}">
          <span
            class="rcc-search__product__price__now ${
              isReduced ?? "rcc-search__product__price__now--reduced"
            }"
          > 
          <span class="rrp-price-label">${isB2B ? "B2B:" : ""}</span>
          ${this.formatPrice(price)}
          </span>
      ${
        !!isReduced
          ? `<span class="rcc-search__product__price__was" aria-hidden="true">
            <span class="rrp-price-label">${isB2B ? "RRP:" : ""}</span>
            ${this.formatPrice(originalPrice)}
            </span>`
          : ""
      }
      </p>`;
    }

    async getVariantRRP() {
      if (!this._product?.variantId) {
        return null;
      }

      const rccContainer = document.querySelector(".rcc-search") || document.querySelector(".rcc-reccomendations");
      const token = rccContainer?.dataset.token;
      if (!token) {
        console.warn("Storefront API token not found");
        return null;
      }

      const variantGid = `gid://shopify/ProductVariant/${this._product.variantId}`;

      const query = `
        query getVariantMetafield($id: ID!) {
          node(id: $id) {
            ... on ProductVariant {
              metafield(namespace: "custom", key: "variant_rrp") {
                value
              }
            }
          }
        }
      `;

      try {
        const response = await fetch("/api/2023-10/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": token,
          },
          body: JSON.stringify({
            query,
            variables: { id: variantGid },
          }),
        });

        const data = await response.json();
        return data?.data?.node?.metafield?.value || null;
      } catch (error) {
        console.error("Error fetching RRP value:", error);
        return null;
      }
    }
  }

  customElements.define("rcc-rrp-price", RrpPricingComponent);
})();
